import { createFileRoute } from '@tanstack/react-router';
import ReceptionPortal from '../../components/portals/ReceptionPortal';
import ReceptionDashboard from '../../components/reception/ReceptionDashboard';

export const Route = createFileRoute('/reception/')({
  component: ReceptionHomeRoute,
});

function ReceptionHomeRoute() {
  return (
    <ReceptionPortal>
      <ReceptionDashboard />
    </ReceptionPortal>
  );
}

